import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox'
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle'
import { ActivatedRoute } from '@angular/router'
import { EventLandingService } from '@app/modules/event-landing-page/services/event-landing.service'
import { LandingPageOption, LandingPageOptions } from '@app/modules/personas/interfaces/persona-landing-option.interface'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'ngx-landing-options',
  templateUrl: './landing-options.component.html',
  styleUrls: ['./landing-options.component.scss'],
  imports: [CommonModule, FormsModule, MatCheckboxModule, MatSlideToggleModule]
})
export class LandingOptionsComponent implements OnInit {
  persona_id: number = this.activatedRoute.snapshot.params.persona_id
  landingOptions: LandingPageOptions
  options: LandingPageOption[]
  private _destroy$ = new Subject()

  ngOnDestroy(): void {
    this._destroy$.next(null)
    this._destroy$.complete()
  }

  constructor(private activatedRoute: ActivatedRoute, private landingService: EventLandingService) {}

  ngOnInit(): void {
    this.landingService.landingOptions$.pipe(takeUntil(this._destroy$)).subscribe((landingOptions: LandingPageOptions) => {
      this.options = Object.values(landingOptions).sort((a, b) => (a.id > b.id ? 1 : -1))
      this.landingOptions = landingOptions
    })
  }

  /**
   * Show/Hide selected section and updates local state
   * @param option LandingPageOption
   * @param checked boolean
   * @returns void
   */
  toggleSections(option: LandingPageOption, { checked }: MatSlideToggle): void {
    if (option.id === 7 && checked) this.landingOptions.contacts.contactsList[0].isEnabled = checked
    option.isEnabled = checked
    this.landingService.updateLandingOptionsLocally(this.landingOptions)
  }

  /**
   * Show/Hide selected contact and updates local state
   * @param checked boolean
   * @returns void
   */
  toggleContacts({ checked }: MatCheckbox): void {
    if (!checked) this.landingOptions.contacts.isEnabled = false
    this.landingOptions.contacts.contactsList[0].isEnabled = checked
    this.landingService.contactsList = { ...this.landingService.contactsList, isEnabled: checked }
    this.landingService.updateLandingOptionsLocally(this.landingOptions)
  }
}
